import Button from "components/Button";
import ConfigureAppleCalendar from "components/ConfigureAppleCalendar";
import styles from "./styles.module.scss";

export type OfficeKind =
  | "google-calendar"
  | "microsoft-calendar"
  | "apple-calendar"
  | "google-docs"
  | "office365";

interface Props {
  packageLabel: string;
  kind: OfficeKind;
  onClose: () => void;
  /** Wywoływane po pomyślnym dodaniu integracji pakietu biurowego. */
  onConnected: () => void;
}

const METHOD_NOTE: Record<OfficeKind, string> = {
  "google-calendar":
    "Integracja kalendarza przez konto Google (OAuth — uprawnienia do kalendarza).",
  "microsoft-calendar":
    "Integracja kalendarza przez konto Microsoft (OAuth — uprawnienia do kalendarza).",
  "apple-calendar":
    "Integracja kalendarza Apple (iCloud) — konfiguracja poświadczeń.",
  "google-docs":
    "Integracja edytora dokumentów przez konto Google (OAuth — Google Docs).",
  office365:
    "Integracja pakietu Office 365 przez konto Microsoft (OAuth — pakiet Microsoft 365).",
};

const OfficeIntegrationWizard = ({
  packageLabel,
  kind,
  onClose,
  onConnected,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{packageLabel}</div>
      <div className={styles.note}>{METHOD_NOTE[kind]}</div>

      {/* Apple calendar — realny konfigurator. */}
      {kind === "apple-calendar" ? (
        <div className={styles.methodBody}>
          <ConfigureAppleCalendar
            onSuccess={() => onConnected()}
            toggle={onClose}
          />
        </div>
      ) : (
        <div className={styles.actions}>
          <Button
            className={styles.connectBtn}
            text={`Połącz — ${packageLabel}`}
            onClick={() => onConnected()}
          />
          <button className={styles.cancelBtn} onClick={onClose}>
            Anuluj
          </button>
        </div>
      )}
    </div>
  );
};

export default OfficeIntegrationWizard;
